import { render, staticRenderFns } from "./user_bills.vue?vue&type=template&id=6ce658e3&"
import script from "./user_bills.vue?vue&type=script&lang=js&"
export * from "./user_bills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports